import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'

import Alert from 'src/components/atoms/alert'
import AuthTemplate from 'src/components/atoms/authTemplate'
import Button from 'src/components/atoms/button'
import Input from 'src/components/atoms/input'
import Form, { FormItem } from 'src/components/forms'
import useAPIRequest from 'src/hooks/useAPIRequest'
import { routes } from 'src/routes/routes'

import apiClient from '../../apiClient'

export default function ForgotPassword() {
    const location = useLocation()
    const [username, setUsername] = useState<string>(location?.state?.username ? location.state.username : '')

    const { callAPI, loading, error, success } = useAPIRequest(apiClient.forgotPassword)

    const { t } = useTranslation()

    useEffect(() => {
        setUsername(location?.state?.username ? location.state.username : '')
    }, [location])

    const onSubmit = (username: string) => callAPI({ username })

    return (
        <AuthTemplate>
            <Form
                layout="vertical"
                disabled={loading}
                onFinish={(values) => onSubmit(values.username || username)}
                className="w-full"
                initialValues={{ username }}
            >
                <FormItem
                    className="mb-2"
                    rules={[{ required: true, message: t('Please add e-mail') }]}
                    label={t('E-mail')}
                    name="username"
                >
                    <Input autoFocus size="large" placeholder={t('Enter e-mail')} />
                </FormItem>

                {error && <Alert message={error} type="error" data-testid="error-forgot-password" />}

                {success && (
                    <Alert
                        message={t(
                            'If the account exists, the instructions to reset your password will be send to your email address.',
                        )}
                        type="success"
                        data-testid="success-forgot-password"
                    />
                )}

                <FormItem className="mt-2">
                    <Button htmlType="submit" type="primary" block disabled={loading} loading={loading}>
                        {t('Send mail', 'Send mail')}
                    </Button>
                </FormItem>

                <div className="mt-4 flex w-full items-center justify-center">
                    <Link
                        to={routes.LOGIN}
                        state={{ username: username }}
                        className="text-[14px] text-gray-900 underline transition hover:text-gray-800"
                    >
                        {t('Back to login')}
                    </Link>
                </div>
            </Form>
        </AuthTemplate>
    )
}
